import { changePageState } from 'actions/import';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getUserCustomer } from 'selectors/auth';
import { getIntegrationSettings } from 'selectors/integrationSettings';
import { useCasesOptions } from '../EditIntegrationSettings/IntegrationSettingsUseCases';

const ImportReviewIntegrationSettings: React.FC = () => {
  const dispatch = useDispatch();

  const integrationSettings = useSelector(getIntegrationSettings);
  const customer = useSelector(getUserCustomer);

  const handleIntegrationSettings = (): void => {
    dispatch(changePageState(3));
  };

  return (
    <div className="flex flex-col gap-4 text-body bg-white">
      <div className="flex flex-row justify-between">
        <span className="text-heading-3">Integrations Settings</span>
        <button
          type="button"
          onClick={handleIntegrationSettings}
          className="text-litlingo-primary underline focus:outline-none"
        >
          Edit Settings
        </button>
      </div>
      {integrationSettings ? (
        <div className="pl-8 flex flex-col gap-2">
          <div className="flex flex-col gap-1">
            <p>
              Legal hold: <b>{integrationSettings.legal_hold ? 'Yes' : 'No'}</b>
            </p>
            <p>
              Email and chat retention policy:{' '}
              <b>{integrationSettings.email_chat_retention_policy || 'None'}</b>
            </p>
            <p>
              LitLingo retention policy:{' '}
              <b>{customer?.config?.communication_retention_days || 0} days</b>
            </p>
          </div>
          <p>
            Use Cases:{' '}
            <b>
              {integrationSettings.use_case_uuids
                .map((u) => useCasesOptions.find((us) => us.value === u)?.label)
                .join(',')}
            </b>
          </p>
          <div className="flex flex-col gap-1">
            <p>
              Translations needed: <b>{integrationSettings.translations_needed ? 'Yes' : 'No'}</b>
            </p>
            <p>
              Additional language offerings (besides English) needed for Prevent:{' '}
              <b>{integrationSettings.additional_language_offerings ? 'Yes' : 'No'}</b>
            </p>
            <p>
              Languages for a better Prevent experience:{' '}
              <b>{integrationSettings.languages_for_better_prevent}</b>
            </p>
          </div>
        </div>
      ) : (
        <div className="">Integration settings not defined</div>
      )}
    </div>
  );
};

export default ImportReviewIntegrationSettings;
